import { z } from 'zod';

export const requestMagicLinkSchema = z.object({
  email: z.string().trim().email('Please enter a valid email address'),
});

export type RequestMagicLinkValues = z.infer<typeof requestMagicLinkSchema>;
